import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const replaceBillingProfileWithNew = (apiUrl) => (id, data) => {
  const url = joinUrl(
    apiUrl,
    `/checkoutservice/pb/billing-profiles/${id}/replace-with-new/`
  );
  return requestUtility.post(url, data);
};

export default replaceBillingProfileWithNew;
